import { rem } from '@mantine/styles';

function getSizeValue(value) {
  return rem(value);
}
function identity(value) {
  return value;
}

export { getSizeValue, identity };
//# sourceMappingURL=get-default-value.js.map
